import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

type DateComparitor = (prevDate: Date, currDate: Date) => boolean;
interface DateConfig {
	fields: string[];
	dateComparitor?: DateComparitor;
	errorKey?: string;
}

const DATE_ERROR_KEY_DEFAULT = 'dateComparison';
const DATE_COMPARITOR_DEFAULT: DateComparitor = (prevDate: Date, currentDate: Date) => prevDate < currentDate;

export function dateComparitorValidator(dateConfig: DateConfig): ValidatorFn;
export function dateComparitorValidator(...fields: string[]): ValidatorFn;
export function dateComparitorValidator(...dateConfigOrFields: string[] | DateConfig[]): ValidatorFn {
	let dates: string[];
	let dateErrorKey: string;
	let dateComparitor: DateComparitor;
	if (typeof dateConfigOrFields[0] === 'object') {
		const dateConfig: DateConfig = dateConfigOrFields[0];
		dates = dateConfig.fields;
		dateErrorKey = dateConfig.errorKey || DATE_ERROR_KEY_DEFAULT;
		dateComparitor = dateConfig.dateComparitor || DATE_COMPARITOR_DEFAULT;
	} else {
		dates = dateConfigOrFields as string[];
		dateErrorKey = DATE_ERROR_KEY_DEFAULT;
		dateComparitor = DATE_COMPARITOR_DEFAULT;
	}
	return (group: UntypedFormGroup) => {
		if (!group || !dates || !dates.length) {
			return null;
		}
		const values = dates
			.filter(dateCtrl => !!group.get(dateCtrl) && !!group.get(dateCtrl).value)
			.map(dateCtrl => group.get(dateCtrl).value);
		if (!values.length) {
			return null;
		}

		const valid = values.slice().reduce((validSoFar, value, idx, arr) => {
			if (!validSoFar) {
				return false;
			}
			if (idx === 0) {
				return true;
			}
			const currentDate = new Date(value);
			const prevDate = new Date(arr[idx - 1]);
			return dateComparitor(prevDate, currentDate);
		}, true);

		return valid ? null : { [dateErrorKey]: true };
	};
}
